<template>
  <div class="container">
    <nuxt-child />
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  layout: 'login',
};
</script>

<style lang="scss" scoped>
@import '~assets/css/shared.scss';

.container {
  align-items: center;
  background-color: $white-grey-2;
  display: flex;
  height: 100vh;
  justify-content: center;
  max-width: none;
  padding: 0 1rem;
  width: 100vw;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */

  .container {
    display: block;
  }

  .container .login_card {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
